import {ThemeEngineAPI, MosaicAPI} from '../../portal/src/api';
import moment from 'moment';

const themeEngine = new ThemeEngineAPI();
const mosaic = new MosaicAPI();


export const rechargeUtil = {
  nextCharge(charges) {
    if (charges.length !== 0) {
      const sorted = charges.sort((a, b) => {
        return moment(a.scheduled_at) - moment(b.scheduled_at);
      });

      const queuedCharges = sorted.filter((charge) => {
        return charge.status === 'QUEUED';
      });

      return queuedCharges[0];
    }
  },

  async updateAddressSubscriptions(addressId, subscriptions, shipping) {
    await mosaic.post('/recharge/subscriptions-bulk-replace', {
      address_id: addressId,
      subscriptions,
      shipping,
    });
  },

  getRechargeData(callback) {
    const response = themeEngine.request_objects('{ "subscriptions": [], "addresses": [], "charges": [] }');

    response.then(({subscriptions, addresses, charges}) => {

      window.mosaic.recharge = {
        subscriptions,
        addresses,
        nextCharge: this.nextCharge(charges),
      };
      if (callback) {
        callback();
      }
    });
  },

  getBundleParent() {
    return window.mosaic.recharge.subscriptions.find(
      sub => sub.shopify_product_id === window.themeConfiguration.bundleArchitecture.product.id
    );
  },

  bundleMode() {
    return this.getBundleParent() != null;
  },

  async getBundleSelection() {

    if (window.mosaic.recharge.bundleSelection) {
      return window.mosaic.recharge.bundleSelection;
    }

    const bundleParent = this.getBundleParent();

    if (!bundleParent) {
      console.error('No bundle subscription found');
      return [];
    }
    const session = await recharge.auth.loginShopifyAppProxy();
    const {bundle_selections} = await window.recharge.bundle.listBundleSelections(
      session,
      {
        purchase_item_ids: bundleParent.id.toString() 
      },
    );
    window.mosaic.recharge.bundleSelection = bundle_selections[0];
    return bundle_selections[0];
  },

};
